import React, { FunctionComponent } from 'react';
import { ScreenReaderContainer } from 'components';
import { Excess } from 'scenes/common/types';

export const ScreenReaderExcessUpdate: FunctionComponent<{
  coverType: string;
  price: string;

  excess: Excess;
}> = ({ coverType, price, excess }) => {
  const { amount } = excess;
  return (
    <ScreenReaderContainer>{`Your ${coverType} insurance quote is $${price} including GST and Government charges, based on a $${amount} excess`}</ScreenReaderContainer>
  );
};

export default ScreenReaderExcessUpdate;
